"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _d = _interopRequireDefault(require("../../lib/d3"));

var _chart = _interopRequireDefault(require("./chart"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var StackedAreaChart = /*#__PURE__*/function (_Chart) {
  _inherits(StackedAreaChart, _Chart);

  var _super = _createSuper(StackedAreaChart);

  function StackedAreaChart() {
    _classCallCheck(this, StackedAreaChart);

    return _super.apply(this, arguments);
  }

  _createClass(StackedAreaChart, [{
    key: "init",
    value: function init() {
      var _this = this;

      _get(_getPrototypeOf(StackedAreaChart.prototype), "init", this).call(this);

      this.layout = _d.default.stack();
      this.areaPathGenerator = _d.default.area().x(function (d, i) {
        return _this.x(d.data[0]);
      }).y0(function (d) {
        return _this.y(d[0]);
      }).y1(function (d) {
        return _this.y(d[1]);
      });
    }
  }, {
    key: "initDOM",
    value: function initDOM() {
      var _this$params = this.params,
          margins = _this$params.margins,
          chartClass = _this$params.chartClass; // high-level DOM elements

      this.svg = _d.default.select(this.container).append('svg').attr('class', "stacked-area ".concat(chartClass || '')).attr('transform-origin', '0 0 0');
      this.g = this.svg.append('g').attr('transform', "translate(".concat(margins.left, ", ").concat(margins.top, ")")); // axes

      this.xAxisGroup = this.g.append('g').attr('class', 'x axis');
      this.yAxisGroup = this.g.append('g').attr('class', 'y axis'); // path group

      this.pathGroup = this.g.append('g').attr('class', 'path-layers');
      this.eventCapture = this.pathGroup.append('rect').style('visibility', 'hidden').attr('x', 0).attr('y', 0);
      this.clipPathRect = this.pathGroup.append('clipPath').attr('id', this.clipPathId).append('rect');
    }
  }, {
    key: "defaultParams",
    get: function get() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(StackedAreaChart.prototype), "defaultParams", this)), {}, {
        x: {
          tickSeparation: 120,
          minTickThreshold: 60
        },
        y: {
          tickSeparation: 50,
          minTickThreshold: 40
        }
      });
    }
  }, {
    key: "initScales",
    value: function initScales() {
      this.x = _d.default.scaleTime();
      this.y = _d.default.scaleLinear();
    }
  }, {
    key: "valueAccessor",
    value: function valueAccessor(d) {
      return d;
    }
  }, {
    key: "getDataStacked",
    value: function getDataStacked() {
      var _this2 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var contiguityThreshold = this.params.contiguityThreshold;
      var dataGroupedByTimestamp = [];
      data = this.preTransformData(data);
      var ids = data // map out the ids
      .map(function (d) {
        return d.id;
      });
      this.layout.keys(ids).value(function (d, key) {
        return d[1][ids.indexOf(key)];
      }).order(function (series) {
        return series.map(function (s) {
          return ids.indexOf(s.key);
        });
      }); // sort by deviation
      // data.sort(
      //   (a,b) => d3.deviation(a.values.map(v => v.w)) - d3.deviation(b.values.map(v => v.w))
      // );

      data.forEach(function (c) {
        c.values.forEach(function (v) {
          var date = new Date(v.t * 1000);
          var timestampRow = dataGroupedByTimestamp.find(function (r) {
            return r[0].getTime() === date.getTime();
          });

          if (!timestampRow) {
            timestampRow = [date, []];
            dataGroupedByTimestamp.push(timestampRow);
          }

          timestampRow[1].push(_this2.valueAccessor(v));
        });
      }); // sort timestamps

      dataGroupedByTimestamp.sort(function (a, b) {
        return b[0] - a[0];
      });
      dataGroupedByTimestamp = this.postTransformData(dataGroupedByTimestamp);
      this.dataGroupedByTimestamp = dataGroupedByTimestamp;
      return (0, _utils.computeGapsInSeriesData)({
        data: this.dataGroupedByTimestamp,
        threshold: contiguityThreshold
      }).map(function (contiguousGroup) {
        return _this2.layout(contiguousGroup);
      });
    }
  }, {
    key: "update",
    value: function update(data) {
      if (data) {
        this.data = data;
      }

      if (!this.data || !this.data.length) {
        return;
      }

      this.layoutGroups = this.getDataStacked(this.data);
      this.flattenedLayoutData = this.layoutGroups.reduce(function (acc, v) {
        return acc.concat(v);
      }, []);

      if (this.flattenedLayoutData.length) {
        this.x = this.x.domain(_d.default.extent(this.flattenedLayoutData.map(function (v) {
          return [v[0].data[0], v[v.length - 1].data[0]];
        }).reduce(function (acc, v) {
          return acc.concat(v);
        }, [])));
        this.y = this.y.domain(_d.default.extent(this.flattenedLayoutData.reduce(function (acc, v) {
          return acc.concat(v.map(function (i) {
            return i[1];
          }));
        }, []) // make sure zero is always present
        .concat([0])));
      }

      this.draw();
    }
  }, {
    key: "buildXAxis",
    value: function buildXAxis() {
      var height = this.dimensions.height;
      var x = this.params.x;
      return _d.default.axisBottom(this.x).tickValues(_utils.generateTickValuesInclusive.call(this, {
        scale: this.x,
        tickSeparation: x.tickSeparation,
        minTickThreshold: x.minTickThreshold,
        valueAccessor: function valueAccessor(v) {
          return new Date(v);
        }
      })).tickFormat(this.params.tickFormats.x).tickPadding(10).tickSizeOuter(0).tickSizeInner(-height);
    }
  }, {
    key: "buildYAxis",
    value: function buildYAxis() {
      var width = this.dimensions.width;
      var y = this.params.y;

      var axis = _d.default.axisLeft(this.y).tickValues(_utils.generateTickValuesInclusive.call(this, {
        scale: this.y,
        tickSeparation: y.tickSeparation,
        minTickThreshold: y.minTickThreshold
      })).tickSize(0).tickSizeInner(-width);

      if (typeof this.params.tickFormats.y === 'function') {
        axis.tickFormat(this.params.tickFormats.y);
      }

      return axis;
    }
  }, {
    key: "draw",
    value: function draw() {
      var _this3 = this;

      var margins = this.params.margins;
      var _this$dimensions = this.dimensions,
          width = _this$dimensions.width,
          height = _this$dimensions.height;

      if (!this.layoutGroups || !this.layoutGroups.length) {
        return;
      }

      this.svg.attr('width', width + margins.left + margins.right).attr('height', height + margins.top + margins.bottom);
      this.x = this.x.range([0, width]);
      this.y = this.y.range([height, 0]);
      this.contiguousGroups = this.pathGroup.selectAll('g.contiguous').data(this.layoutGroups);
      this.contiguousGroupsEnter = this.contiguousGroups.enter().append('g').attr('class', 'contiguous'); // create instance vars for layer selections

      this.layers = [];
      this.layersEnter = [];
      this.layersEnterUpdate = [];
      this.layersExit = [];
      this.contiguousGroupsEnterUpdate = this.contiguousGroups.merge(this.contiguousGroupsEnter).each(function (data, i, nodeList) {
        var group = _d.default.select(nodeList[i]);

        var layers = group.selectAll('path.layer').data(data, function (d) {
          return d.key;
        });
        var layersEnter = layers.enter().append('path').attr('class', 'layer').attr('clip-path', "url(#".concat(_this3.clipPathId, ")")).attr('fill', _this3.getColor.bind(_this3));
        var layersEnterUpdate = layers.merge(layersEnter).attr('d', _this3.areaPathGenerator);
        var layersExit = layers.exit().remove(); // create instance vars for layer selections

        _this3.layers.push(layers);

        _this3.layersEnter.push(layersEnter);

        _this3.layersEnterUpdate.push(layersEnterUpdate);

        _this3.layersExit.push(layersExit);
      });
      this.contiguousGroups.exit().remove();
      this.xAxisGroup.attr('transform', "translate(0,".concat(height, ")")).call(this.buildXAxis());
      this.eventCapture.attr('width', width).attr('height', height);
      this.clipPathRect.attr('width', width).attr('height', height).attr('transform', 'translate(1,0)');
      this.yAxisGroup.call(this.buildYAxis());

      _d.default.selectAll('.axis .domain').raise();
    }
  }]);

  return StackedAreaChart;
}(_chart.default);

exports.default = StackedAreaChart;